// extracted by mini-css-extract-plugin
module.exports = {"landing":"landingPage_landing__aoLeI"};